export function getGroupConversationsList(state) {
    return state.groupConversationList;
}